import Axios from 'axios';
import {Col,Row,Container} from 'reactstrap'; 
import React, { useState, useEffect } from 'react';

const GamePlanet = () =>{
        const [activeLetter, setActiveLetter] = useState("")
        const [filterPlanetResult, setFilterPlanetResult] = useState('All')
        const [planets, setPlanets] = useState([])

        useEffect(() => {
        const APIfetch = async () => {
            const result = await Axios(`https://api.le-systeme-solaire.net/rest/bodies/`);
            setPlanets(result.data.bodies)
        } 
        APIfetch()
        },[]);
 
        const filterWithLetters =(letter,objects) => {
            return(
                objects.filter(planet=> filterPlanetResult==="All"?
                planet.name[0]===letter:
                planet.name[0]===letter && planet.isPlanet===filterPlanetResult )
            )
        }
        const getWithin =(object)=>{
            return(
                Object.keys(object).filter(key=>object[key] !== 0  && object[key] !== null && object[key] !== undefined)
                .map(keyOK=>
                typeof object[keyOK]== "object"?
                getWithin(object[keyOK])    
                :<li key={keyOK}><strong>{keyOK}</strong> : {String(object[keyOK])}  
                </li>)
            )
        } 
        const chooseLetter = () => {
            const alpha = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"]
            .map(letter => 
                filterWithLetters(letter,planets).length>0?
                <button className="greenLetters" key={letter} 
                        onClick={()=>setActiveLetter(letter)}>
                           {letter}
                </button>
                :
                <button key={letter} 
                disabled={true}>
                    {letter}
        </button>)


            return(<>
                {alpha}
                </>)
            }
        
            return(
                <>
                <div id="gameplanetContainer">
                    <img className="background" alt="" src="https://i.pinimg.com/originals/db/cf/75/dbcf75c4077af50d9ac5691987fdee34.jpg"/>
                    <Row className="activeLetter">  <h2>{activeLetter}</h2></Row>
                    <Row className="alphabet">{chooseLetter()} </Row>
                    <Row className="choosePlanet">
                        <select>
                            <option value="All" onClick={()=>setFilterPlanetResult("All")}>All</option>
                            <option value="true" onClick={()=>setFilterPlanetResult(true)}>Planet</option>
                            <option value="false" onClick={()=>setFilterPlanetResult(false)}>Not a planet</option>
                        </select> 
                    </Row>
                    <Row className="planetListing">
                        {filterWithLetters(activeLetter,planets)
                        .map(planetOK =>  
                            <Col sm="4">
                            <ul key={planetOK.id}>
                            <h2>{planetOK.name} </h2>
                            {getWithin(planetOK)}  
                            </ul>
                            </Col>)}
                    </Row>
                </div>
                </>
            )}

export default GamePlanet